import Toast from './common/toast'
import Location from './common/location'
import IpLocation from './common/locationByIp'
import CitySelect from './common/citySelect'
import Share from './common/share'
import lazyComponent from './common/lazyComponent'
export const comments = {
    lazyComponent
};

function install() {
    Object.keys(comments).forEach((key) => {
        Vue.component(key, comments[key]);
    });
    Vue.prototype.$UI = {
        location: Location,
        ipLocation: IpLocation,
        toast: Toast,
        citySelect: CitySelect,
        share: Share
    }
};
install()
export default {
    install
}
